import { ValidationResultResponse } from '@interfaces/partners/responses/validation-result.response';
import { unwrapValidation } from '@services/http/partners/unwrap-validation.operator';
import { OperatorFunction, of, switchMap } from 'rxjs';

/** Arquivo do PDF baixado de um contrato, com o nome que o backend mandou no `Content-Disposition`. */
export interface ContractPdfFile {
  blob: Blob;
  fileName: string;
}

/**
 * Desembrulha a resposta dos endpoints de contrato (parceria e cliente, cards 3462 e 3643) aceitando
 * os dois formatos do backend: `T` direto ou `ValidationResult<T>`. Recusa aninhada
 * (`isValid: false`) vira `ErrorResponse` pelo `unwrapValidation`, para a tela não mostrar "salvo"
 * de uma recusa.
 */
export function unwrapContractResult<T>(): OperatorFunction<unknown, T | null> {
  return switchMap(body =>
    isValidationResult<T>(body)
      ? of(body).pipe(unwrapValidation<T, null>(null))
      : of((body ?? null) as T | null)
  );
}

function isValidationResult<T>(body: unknown): body is ValidationResultResponse<T> {
  return (
    !!body &&
    typeof body === 'object' &&
    typeof (body as Partial<ValidationResultResponse<T>>).isValid === 'boolean' &&
    Array.isArray((body as Partial<ValidationResultResponse<T>>).results)
  );
}
